import { Component, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { Location } from '@angular/common';
import { OrganizationalUnitEnvelope } from '../../../../models/net/envelope/organizational-unit-envelope';
import { AppService } from '../../../../services/app.service';
import { OrganizationalUnitService } from '../../../../services/organizational-units/organizational-unit.service';
import { ActivatedRoute } from '@angular/router';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AvatarPrimitive } from '../../../../models/app/avatar-primitive';
import { ChipSelectorComponent } from '../../../fragments/chip-selector/chip-selector.component';
import { OrganizationalUnitDocument } from '../../../../models/net/envelope/documents/organizational-unit-document';
import { OrganizationalUnitGroup } from '../../../../models/data/app-core/organizational-unit-group';
import { Group } from '../../../../models/data/app-core/group';
import { OrganizationalUnitPerson } from '../../../../models/data/app-core/organizational-unit-person';
import { OrganizationalUnit } from '../../../../models/data/app-core/organizational-unit';
import { Person } from '../../../../models/data/app-core/person';
import { MatTableDataSource } from '@angular/material/table';
import { MembershipStatus } from '../../../../models/data/app-core/membership-status';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'app-organization',
    templateUrl: './organization.component.html',
    styleUrls: ['./organization.component.css', '../../../../app.component.css']
})

export class OrganizationComponent extends EditorComponent {

    public avatarUrl: string = "";
    public availablePersons: AvatarPrimitive[] = [];
    public selectedPersonIds: number[] = [];
    public availableGroups: AvatarPrimitive[] = [];
    public selectedGroupIds: number[] = [];
    public availableMembershipStatuses: MembershipStatus[] = [];
    public selectedMembershipStatusId?: number;
    public organizationalUnitPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as OrganizationalUnitDocument).Persons);
    public displayedOrganizationalUnitPersonColumns: string[] = ["Avatar", "FirstName", "LastName", "Status", "Delete"];
    public dynamicClassNamePersonSpan = "expanding-span-collapsed";

    @ViewChild("appHistory") appHistory!: HistoryComponent;
    @ViewChild("groupsChipSelector") groupsChipSelector!: ChipSelectorComponent;
    @ViewChild("personChipSelector") personChipSelector!: ChipSelectorComponent;

    public constructor(public override appService: AppService,
                       public override itemService: OrganizationalUnitService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "org", "orgs");
    }

    public override initializeEnvelope = (envelope: OrganizationalUnitEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new OrganizationalUnitEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        if (this.itemId == 1) {
            this.avatarUrl = "data:image/png;base64,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";
        }

        //const availableMembershipStatuses: AvatarPrimitive[] = (this.itemEnvelope as OrganizationalUnitEnvelope).MembershipStatusPool.map((i: MembershipStatus) => {
        //    let result = new AvatarPrimitive();
        //    result.Id = i.MembershipStatusId;
        //    result.Name = i.UID;
        //    result.AvatarBlobPath = this.appService.defaultImageUri;
        //    return result;
        //});

        const availablePersons: AvatarPrimitive[] = (this.itemEnvelope as OrganizationalUnitEnvelope).PersonsPool.map((i: Person) => {
            let result = new AvatarPrimitive();
            result.Id = i.PersonId;
            result.Name = i.FirstName + ' ' + i.LastName;
            result.AvatarBlobPath = i.AvatarBlobPath ?? this.appService.defaultImageUri;
            return result;
        });

        const availableGroups: AvatarPrimitive[] = (this.itemEnvelope as OrganizationalUnitEnvelope).GroupsPool.map((i: Group) => {
            let result = new AvatarPrimitive();
            result.Id = i.GroupId;
            result.Name = i.Name;
            result.AvatarBlobPath = this.appService.defaultImageUri;
            return result;
        });

        this.availableMembershipStatuses = (this.itemEnvelope as OrganizationalUnitEnvelope).MembershipStatusPool;
        this.availablePersons = availablePersons;
        this.availableGroups = availableGroups;

        this.organizationalUnitPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as OrganizationalUnitDocument).Persons)

        this.selectedGroupIds = (this.itemEnvelope?.Document as OrganizationalUnitDocument).Groups.map(i => i.GroupId);
    }

    public ngAfterViewInit(): void {

        this.groupsChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.selectedGroupIds.push(item.Id);
            this.addGroupToOrganizationalUnit(item.Id);
        });

        this.groupsChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.selectedGroupIds.splice(this.selectedGroupIds.indexOf(item.Id), 1);
            this.removeGroupFromOrganizationalUnit(item.Id);
        });

        this.personChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.selectedPersonIds.push(item.Id);
        });

        this.personChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.selectedPersonIds = [];
        });
    }

    public addGroupToOrganizationalUnit = (groupId: number): void => {

        const document: OrganizationalUnitDocument = (this.itemEnvelope?.Document as OrganizationalUnitDocument);
        var newOrganizationalUnitGroup: OrganizationalUnitGroup = new OrganizationalUnitGroup();

        newOrganizationalUnitGroup.OrganizationalUnitId = document.Item.OrganizationalUnitId;
        newOrganizationalUnitGroup.GroupId = groupId; 

        document.Groups.push(newOrganizationalUnitGroup);
    }

    public removeGroupFromOrganizationalUnit = (groupId: number): void => {

        const document: OrganizationalUnitDocument = (this.itemEnvelope?.Document as OrganizationalUnitDocument);

        const itemIndex: number | undefined = document.Groups.map((i: OrganizationalUnitGroup) => i.GroupId).indexOf(groupId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            document.Groups.splice(itemIndex, 1);
        }
    }

    public override handleEditMode = (): void => {

        this.appService.navigateTo("org/" + this.itemId.toString(), "");
    }

    public onTabChange(event: MatTabChangeEvent) {

        if (event.index == 1 && !this.isRevisionListLoaded) {

            this.appHistory.searchRevisions();
        }
    }

    public addMember = (): void => {

        this.appService.showPendingFeatureDialog();
    }

    public addPersonToOrganizationalUnit = (): void => {

        let newOrganizationalUnitPerson: OrganizationalUnitPerson = new OrganizationalUnitPerson();

        if (this.dynamicClassNamePersonSpan == "expanding-span-collapsed") {

            this.dynamicClassNamePersonSpan = "expanding-span-expanded";

        } else {

            newOrganizationalUnitPerson.OrganizationalUnitId = (this.itemEnvelope?.Document?.Item as OrganizationalUnit).OrganizationalUnitId;
            newOrganizationalUnitPerson.PersonId = this.selectedPersonIds[0];

            (this.itemEnvelope?.Document as OrganizationalUnitDocument).Persons.push(newOrganizationalUnitPerson);
            this.organizationalUnitPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as OrganizationalUnitDocument).Persons);

            if (this.personChipSelector.selectedItems.length > 0) {

                this.personChipSelector.remove(this.personChipSelector.selectedItems[0]);
            }

            this.dynamicClassNamePersonSpan = "expanding-span-collapsed";
        }
    }

    public getAvatarBlobPathFromPersonId = (personId: number): string | undefined => {

        let result: string | undefined = "";

        let person: Person | undefined = (this.itemEnvelope as OrganizationalUnitEnvelope)?.PersonsPool.find((i: Person) => i.PersonId == personId);

        if (person) {

            result = person.AvatarBlobPath;
        }

        return result;
    }

    public getFirstNameFromPersonId = (personId: number): string | undefined => {

        let result: string | undefined = "";

        let person: Person | undefined = (this.itemEnvelope as OrganizationalUnitEnvelope)?.PersonsPool.find((i: Person) => i.PersonId == personId);

        if (person) {

            result = person.FirstName;
        }

        return result;
    }

    public getLastNameFromPersonId = (personId: number): string | undefined => {

        let result: string | undefined = "";

        let person: Person | undefined = (this.itemEnvelope as OrganizationalUnitEnvelope)?.PersonsPool.find((i: Person) => i.PersonId == personId);

        if (person) {

            result = person.LastName;
        }

        return result;
    }

    public cancelAddPersonToOrganizationalUnit = (): void => {

        this.dynamicClassNamePersonSpan = "expanding-span-collapsed";
        this.personChipSelector.clear();
        this.selectedPersonIds = [];

        if (this.personChipSelector.selectedItems.length > 0) {

            this.personChipSelector.remove(this.personChipSelector.selectedItems[0]);
        }
    }

    public deleteOrganizationalUnitPerson = (organizationalUnitPerson: OrganizationalUnitPerson): void => {

        const itemIndex: number | undefined = (this.itemEnvelope?.Document as OrganizationalUnitDocument)?.Persons.map((i: OrganizationalUnitPerson) => i.OrganizationalUnitPersonId).indexOf(organizationalUnitPerson.OrganizationalUnitPersonId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            (this.itemEnvelope?.Document as OrganizationalUnitDocument)?.Persons.splice(itemIndex, 1);
            this.organizationalUnitPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as OrganizationalUnitDocument).Persons);
        }
    }

    public onMembershipStatusChange = (event: MatSelectChange): void => {

        this.selectedMembershipStatusId = event.value as number;
    }

    public getUIDFromMembershipStatusId = (membershipStatusId: number): string | undefined => {

        let result: string | undefined = "";

        let membershipStatus: MembershipStatus | undefined = (this.itemEnvelope as OrganizationalUnitEnvelope)?.MembershipStatusPool.find((i: MembershipStatus) => i.MembershipStatusId == membershipStatusId);

        if (membershipStatus) {

            result = membershipStatus.UID;
        }

        return result;
    }
}
